const uuidv4 = require('uuid/v4')
/* eslint-disable */
export function slugify(text) {
  return uuidv4();
}



// WEBPACK FOOTER //
// ./utils/slugify.js